import React from 'react';

type ImageGalleryImageProps = { src?: string; alt?: string };

export function GalleryImage({ src, alt }: ImageGalleryImageProps) {
  return (
    <div className="image-gallery__image-container-background">
      <img src={src} alt={alt} width="320" loading="lazy" className="image-gallery__upload-preview" />
    </div>
  );
}
